(function () {
  const CDN = 'https://cdn.shopify.com/s/files/1/0710/3525/7065/files';

  const COUNTRIES = [
    { key: 'USA', label: 'USA', flag: `${CDN}/USA.svg` },
    { key: 'Canada', label: 'Canada', flag: `${CDN}/Canada.svg` },
    { key: 'UK', label: 'UK', flag: `${CDN}/UK.svg` },
    { key: 'Austallia', label: 'Australia', flag: `${CDN}/Austallia.svg` },
    { key: 'Europe', label: 'Europe', flag: `${CDN}/Europe.svg` },
    { key: 'India', label: 'India', flag: `${CDN}/India.svg` },
  ];

  const insideDiameterData = [
    '14.05 & 44.14', '14.24 & 44.74', '14.45 & 45.40', '14.65 & 46.02', '14.88 & 46.80',
    '15.09 & 47.40', '15.29 & 48.00', '15.49 & 48.70', '15.70 & 49.30', '15.90 & 50.00',
    '16.10 & 50.60', '16.31 & 51.20', '16.51 & 51.90', '16.71 & 52.50', '16.92 & 53.10',
    '17.12 & 53.80', '17.32 & 54.40', '17.53 & 55.10', '17.73 & 55.70', '17.93 & 56.30',
    '18.14 & 57.00', '18.34 & 57.60', '18.54 & 58.30', '18.75 & 58.90', '18.95 & 59.50',
    '19.15 & 60.20', '19.35 & 60.80', '19.56 & 61.40', '19.76 & 62.10', '19.96 & 62.70',
    '20.17 & 63.40', '20.37 & 64.00', '20.57 & 64.60', '20.78 & 65.30', '20.98 & 65.90',
    '21.18 & 66.60', '21.39 & 67.20', '21.59 & 67.80', '21.79 & 68.50', '22.00 & 69.10',
    '22.20 & 69.70', '22.40 & 70.40', '22.61 & 71.00', '22.81 & 71.70', '23.01 & 72.30',
    '23.22 & 72.90', '23.42 & 73.60', '23.62 & 74.20', '24.23 & 76.10',
  ];

  const countrySizeData = {
    USA: ['3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.1', '8.25', '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '12.75', '13', '13.25', '13.5', '14', '14.25', '14.5', '14.75', '15'],
    Canada: ['3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.1', '8.25', '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '12.75', '13', '13.25', '13.5', '14', '14.25', '14.5', '14.75', '15'],
    Europe: ['44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71'],
    UK: ['F', 'F.5', 'G', 'G.5', 'H', 'H.5', 'I', 'J', 'J.5', 'K', 'K.5', 'L', 'L.5', 'M', 'M.5', 'N', 'N.5', 'O', 'O.5', 'P', 'P.5', 'Q', 'Q.5', 'R', 'R.5', 'S', 'S.5', 'T', 'T.5', 'U', 'U.5', 'V', 'V.5', 'W', 'W.5', 'X', 'X.5', 'Y', 'Z', 'Z.5', 'Z1', 'Z2', 'Z3', 'Z4'],
    Austallia: ['F', 'F.5', 'G', 'G.5', 'H', 'H.5', 'I', 'J', 'J.5', 'K', 'K.5', 'L', 'L.5', 'M', 'M.5', 'N', 'N.5', 'O', 'O.5', 'P', 'P.5', 'Q', 'Q.5', 'R', 'R.5', 'S', 'S.5', 'T', 'T.5', 'U', 'U.5', 'V', 'V.5', 'W', 'W.5', 'X', 'X.5', 'Y', 'Z', 'Z.5', 'Z1', 'Z2', 'Z3', 'Z4'],
    India: ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27'],
  };

  const countryValueData = {
    USA: ['3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.1', '8.25', '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '12.75', '13', '13.25', '13.5', '14', '14.25', '14.5', '14.75', '15'],
    Canada: ['3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.1', '8.25', '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '12.75', '13', '13.25', '13.5', '14', '14.25', '14.5', '14.75', '15'],
    Europe: ['3', '3.25', '3.75', '4', '4.5', '5', '5.25', '5.75', '6', '6.5', '7', '7.25', '7.75', '8', '8.5', '8.75', '9.25', '9.5', '10', '10.5', '10.75', '11.25', '11.5', '12', '12.5', '12.75', '13', '13.5'],
    UK: ['3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.10', '8.25', '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '13', '13.5', '14', '14.5'],
    Austallia: ['3', '3.25', '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75', '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.10', '8.25', '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75', '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '13', '13.5', '14', '14.5'],
    India: ['3', '3.5', '3.75', '4', '4.5', '5', '5.5', '6', '6.25', '6.5', '7', '7.5', '8', '8.25', '8.75', '9.25', '9.75', '10', '10.25', '10.75', '11.25', '11.75', '12.25', '12.75'],
  };

  const countryByKey = Object.fromEntries(COUNTRIES.map((c) => [c.key, c]));

  function parseMeasurement(raw) {
    const parts = String(raw).split('&').map((s) => parseFloat(s.trim()));
    return { diameter: parts[0], circumference: parts[1] };
  }

  function formatMm(value) {
    const num = parseFloat(value);
    if (Number.isNaN(num)) return value;
    return num.toFixed(2);
  }

  function formatRingSize(size) {
    const str = String(size).trim();
    if (/^[A-Za-z]/.test(str)) return str;
    const num = parseFloat(str);
    if (Number.isNaN(num)) return str;
    return num.toFixed(2);
  }

  function formatDiameterLabel(m) {
    return `${formatMm(m.diameter)} MM`;
  }

  function formatCircumferenceLabel(m) {
    return `${formatMm(m.circumference)} MM`;
  }

  function getMeasurements() {
    return insideDiameterData.map((raw, index) => ({
      index,
      raw,
      ...parseMeasurement(raw),
      usSize: countryValueData.USA[index],
    }));
  }

  function getUsSizeAtIndex(index) {
    return countryValueData.USA[index] || countrySizeData.USA[index];
  }

  function getAllSizesAtIndex(index) {
    const chips = [];
    COUNTRIES.forEach(({ key, label, flag }) => {
      const sizes = countrySizeData[key];
      if (sizes && sizes[index] !== undefined) {
        chips.push({ key, label, flag, size: sizes[index] });
      }
    });
    const measure = insideDiameterData[index] ? parseMeasurement(insideDiameterData[index]) : null;
    return {
      usSize: getUsSizeAtIndex(index),
      chips,
      measure,
    };
  }

  function findGlobalIndexByCountrySize(countryKey, localIndex) {
    const usSizes = countryValueData[countryKey];
    if (!usSizes || localIndex < 0 || localIndex >= usSizes.length) return -1;
    const usSize = String(usSizes[localIndex]);
    let globalIndex = countryValueData.USA.indexOf(usSize);
    if (globalIndex >= 0) return globalIndex;
    globalIndex = countrySizeData.USA.indexOf(usSize);
    return globalIndex;
  }

  function findLocalIndexByCountrySize(countryKey, size) {
    const sizes = countrySizeData[countryKey];
    if (!sizes) return -1;
    return sizes.indexOf(size);
  }

  function findClosestIndexByCircumference(mm) {
    const measurements = getMeasurements();
    let closest = 0;
    let minDiff = Infinity;
    measurements.forEach((m, i) => {
      const diff = Math.abs(m.circumference - mm);
      if (diff < minDiff) {
        minDiff = diff;
        closest = i;
      }
    });
    return { index: closest, diff: minDiff };
  }

  function getBetweenSizesTip(mm, index) {
    const measurements = getMeasurements();
    const current = measurements[index];
    if (!current) return null;

    const next = measurements[index + 1];
    const prev = measurements[index - 1];

    if (next && mm > current.circumference && mm < next.circumference) {
      const low = getUsSizeAtIndex(index);
      const high = getUsSizeAtIndex(index + 1);
      return `Your measurement (${mm} mm) is between <strong>${low}</strong> and <strong>${high}</strong> US. We recommend choosing the larger size <strong>${high} US</strong> for a comfortable fit.`;
    }

    if (prev && mm < current.circumference && mm > prev.circumference) {
      const low = getUsSizeAtIndex(index - 1);
      const high = getUsSizeAtIndex(index);
      return `Your measurement (${mm} mm) is between <strong>${low}</strong> and <strong>${high}</strong> US. We recommend choosing the larger size <strong>${high} US</strong> for a comfortable fit.`;
    }

    if (findClosestIndexByCircumference(mm).diff > 0.5 && findClosestIndexByCircumference(mm).diff < 2) {
      return 'For the most accurate fit, measure at the end of the day when your finger is slightly larger.';
    }

    return null;
  }

  function showEl(el) {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.classList.remove('hidden');
  }

  function hideEl(el) {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('hidden', '');
  }

  class RingSizeConverter {
    constructor(root) {
      this.root = root;
      this.shopUrl = root.dataset.shopUrl || '/collections/engagement-rings';
      this.pdfUrl = root.dataset.pdfUrl || '';
      this.selectedCountry = null;
      this.activeSizeIndex = null;
      this.state = { mode: 'country', measureMode: 'diameter' };

      this.cacheDom();
      this.buildCountryList();
      this.buildDiameterSelect();
      this.buildCircumferenceSelect();
      this.bindEvents();
    }

    cacheDom() {
      const r = this.root;
      this.els = {
        resultEmpty: r.querySelector('[data-rsc-empty]'),
        resultActive: r.querySelector('[data-rsc-active]'),
        resultUs: r.querySelector('[data-rsc-us]'),
        measureLine: r.querySelector('[data-rsc-measure-line]'),
        resultGrid: r.querySelector('[data-rsc-grid]'),
        tip: r.querySelector('[data-rsc-tip]'),
        copyBtn: r.querySelector('[data-rsc-copy]'),
        tabs: r.querySelectorAll('[data-rsc-tab]'),
        panelCountry: r.querySelector('[data-rsc-panel="country"]'),
        panelMeasure: r.querySelector('[data-rsc-panel="measure"]'),
        resultPanel: r.querySelector('[data-rsc-result-panel]'),
        countryTrigger: r.querySelector('[data-rsc-country-trigger]'),
        countryFlag: r.querySelector('[data-rsc-country-flag]'),
        countryLabel: r.querySelector('[data-rsc-country-label]'),
        countryMenu: r.querySelector('[data-rsc-country-menu]'),
        countrySearch: r.querySelector('[data-rsc-country-search]'),
        countryList: r.querySelector('[data-rsc-country-list]'),
        sizePanel: r.querySelector('[data-rsc-size-panel]'),
        sizesGrid: r.querySelector('[data-rsc-sizes-grid]'),
        sizesPlaceholder: r.querySelector('[data-rsc-sizes-placeholder]'),
        countryError: r.querySelector('[data-rsc-country-error]'),
        measureTabs: r.querySelectorAll('[data-rsc-measure-tab]'),
        diameterSelect: r.querySelector('[data-rsc-diameter]'),
        circSelect: r.querySelector('[data-rsc-circ-select]'),
        circInput: r.querySelector('[data-rsc-circumference]'),
        circBtn: r.querySelector('[data-rsc-circ-btn]'),
        measureDiameter: r.querySelector('[data-rsc-measure-diameter]'),
        measureCirc: r.querySelector('[data-rsc-measure-circ]'),
        measureCustom: r.querySelector('[data-rsc-measure-custom]'),
      };

    }

    buildCountryList() {
      this.els.countryList.innerHTML = '';
      COUNTRIES.forEach((country) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rsc__country-item';
        btn.dataset.countryKey = country.key;
        btn.innerHTML = `<img src="${country.flag}" alt="" width="20" height="14" loading="lazy"><span>${country.label}</span>`;
        btn.addEventListener('click', () => this.selectCountry(country.key));
        this.els.countryList.appendChild(btn);
      });
    }

    buildDiameterSelect() {
      const select = this.els.diameterSelect;
      if (!select) return;
      select.innerHTML = '<option value="">Select inside diameter</option>';
      insideDiameterData.forEach((raw, index) => {
        const m = parseMeasurement(raw);
        const opt = document.createElement('option');
        opt.value = String(index);
        opt.textContent = formatDiameterLabel(m);
        select.appendChild(opt);
      });
    }

    buildCircumferenceSelect() {
      const select = this.els.circSelect;
      if (!select) return;
      select.innerHTML = '<option value="">Select circumference</option>';
      insideDiameterData.forEach((raw, index) => {
        const m = parseMeasurement(raw);
        const opt = document.createElement('option');
        opt.value = String(index);
        opt.textContent = formatCircumferenceLabel(m);
        select.appendChild(opt);
      });
    }

    bindEvents() {
      this.els.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setMainTab(tab.dataset.rscTab));
      });

      this.els.measureTabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setMeasureTab(tab.dataset.rscMeasureTab));
      });

      this.els.countryTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleCountryMenu();
      });

      this.els.countrySearch.addEventListener('input', () => this.filterCountries());
      this.els.countrySearch.addEventListener('click', (e) => e.stopPropagation());

      document.addEventListener('click', (e) => {
        if (!this.root.contains(e.target)) {
          this.closeCountryMenu();
        }
      });

      this.els.diameterSelect.addEventListener('change', () => {
        const index = parseInt(this.els.diameterSelect.value, 10);
        if (!Number.isNaN(index)) {
          this.resetCountrySelection();
          this.clearMeasureInputsExcept('diameter');
          this.applyResult(index, {
            contextType: 'diameter',
          });
        }
      });

      if (this.els.circSelect) {
        this.els.circSelect.addEventListener('change', () => {
          const index = parseInt(this.els.circSelect.value, 10);
          if (!Number.isNaN(index)) {
            this.resetCountrySelection();
            this.clearMeasureInputsExcept('circumference');
            this.applyResult(index, {
              contextType: 'circumference',
            });
          }
        });
      }

      this.els.circBtn.addEventListener('click', () => this.applyCircumference());
      this.els.circInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') this.applyCircumference();
      });

      this.els.copyBtn.addEventListener('click', () => this.copySize());
    }

    clearMeasureInputsExcept(keep) {
      if (keep !== 'diameter' && this.els.diameterSelect) this.els.diameterSelect.value = '';
      if (keep !== 'circumference' && this.els.circSelect) this.els.circSelect.value = '';
      if (keep !== 'custom' && this.els.circInput) this.els.circInput.value = '';
    }

    setMainTab(mode) {
      this.state.mode = mode;
      this.els.tabs.forEach((t) => {
        const isActive = t.dataset.rscTab === mode;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.els.panelCountry.hidden = mode !== 'country';
      this.els.panelMeasure.hidden = mode !== 'measure';
    }

    setMeasureTab(mode) {
      this.state.measureMode = mode;
      this.els.measureTabs.forEach((t) => t.classList.toggle('is-active', t.dataset.rscMeasureTab === mode));
      this.els.measureDiameter.hidden = mode !== 'diameter';
      this.els.measureCirc.hidden = mode !== 'circumference';
      if (this.els.measureCustom) this.els.measureCustom.hidden = mode !== 'custom';
    }

    toggleCountryMenu() {
      const open = !this.els.countryMenu.hidden;
      if (open) {
        this.closeCountryMenu();
      } else {
        this.els.countryMenu.hidden = false;
        this.els.countryTrigger.classList.add('is-open');
        this.els.countryTrigger.setAttribute('aria-expanded', 'true');
        this.els.countrySearch.value = '';
        this.filterCountries();
        this.els.countrySearch.focus();
      }
    }

    closeCountryMenu() {
      this.els.countryMenu.hidden = true;
      this.els.countryTrigger.classList.remove('is-open');
      this.els.countryTrigger.setAttribute('aria-expanded', 'false');
    }

    filterCountries() {
      const q = this.els.countrySearch.value.trim().toLowerCase();
      this.els.countryList.querySelectorAll('.rsc__country-item').forEach((item) => {
        const label = item.textContent.toLowerCase();
        item.hidden = q && !label.includes(q);
      });
    }

    selectCountry(countryKey) {
      this.selectedCountry = countryByKey[countryKey];
      if (!this.selectedCountry) return;

      this.closeCountryMenu();
      this.els.countryError.hidden = true;

      const c = this.selectedCountry;
      this.els.countryFlag.src = c.flag;
      this.els.countryFlag.alt = c.label;
      showEl(this.els.countryFlag);
      this.els.countryLabel.textContent = c.label;

      this.els.countryList.querySelectorAll('.rsc__country-item').forEach((item) => {
        item.classList.toggle('is-selected', item.dataset.countryKey === countryKey);
      });

      this.renderSizeOptions(countryKey);
      this.clearResult();
      this.clearMeasureInputsExcept(null);
    }

    resetCountrySelection() {
      this.selectedCountry = null;
      this.els.countryFlag.src = '';
      hideEl(this.els.countryFlag);
      this.els.countryLabel.textContent = 'Select country';
      if (this.els.sizesGrid) {
        this.els.sizesGrid.innerHTML = '';
      }
      hideEl(this.els.sizePanel);
      showEl(this.els.sizesPlaceholder);
      this.els.sizesPlaceholder.classList.remove('is-hidden');
    }

    renderSizeOptions(countryKey) {
      const sizes = countrySizeData[countryKey] || [];
      const usSizes = countryValueData[countryKey] || [];

      this.els.sizesPlaceholder.classList.add('is-hidden');
      hideEl(this.els.sizesPlaceholder);
      showEl(this.els.sizePanel);

      if (!this.els.sizesGrid) return;
      this.els.sizesGrid.innerHTML = '';

      sizes.forEach((size, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rsc__size-chip';
        btn.textContent = formatRingSize(size);
        btn.dataset.index = String(index);
        btn.addEventListener('click', () => {
          this.applyCountrySize(countryKey, index);
          this.els.sizesGrid.querySelectorAll('.rsc__size-chip').forEach((chip) => {
            chip.classList.toggle('is-active', chip === btn);
          });
        });
        this.els.sizesGrid.appendChild(btn);
      });
    }

    applyCountrySize(countryKey, localIndex) {
      const usSizes = countryValueData[countryKey] || [];
      const sizes = countrySizeData[countryKey] || [];
      const country = countryByKey[countryKey];
      const sizeLabel = sizes[localIndex];
      const globalIndex = findGlobalIndexByCountrySize(countryKey, localIndex);

      this.els.diameterSelect.value = '';
      if (this.els.circSelect) this.els.circSelect.value = '';
      this.els.circInput.value = '';

      if (globalIndex >= 0) {
        this.applyResult(globalIndex, {
          contextType: 'country',
          contextLabel: country.label,
          contextValue: formatRingSize(sizeLabel),
        });
      } else {
        const us = usSizes[localIndex];
        this.showPartialResult(us);
      }
    }

    applyCircumference() {
      const raw = parseFloat(this.els.circInput.value);
      if (Number.isNaN(raw) || raw < 40 || raw > 80) {
        this.els.circInput.setCustomValidity('Enter a valid circumference between 40–80 mm');
        this.els.circInput.reportValidity();
        return;
      }
      this.els.circInput.setCustomValidity('');

      const { index } = findClosestIndexByCircumference(raw);
      const tip = getBetweenSizesTip(raw, index);
      this.resetCountrySelection();
      this.clearMeasureInputsExcept('custom');
      this.applyResult(index, {
        contextType: 'custom',
        contextValue: formatMm(raw),
        tip,
      });
      if (this.els.diameterSelect) this.els.diameterSelect.value = String(index);
      if (this.els.circSelect) this.els.circSelect.value = String(index);
    }

    renderResultDetails({ measure }) {
      if (measure && this.els.measureLine) {
        this.els.measureLine.textContent = `${formatMm(measure.diameter)} mm diameter · ${formatMm(measure.circumference)} mm circumference`;
        showEl(this.els.measureLine);
      } else {
        hideEl(this.els.measureLine);
      }
    }

    applyResult(index, { contextType, contextLabel, contextValue, tip }) {
      this.activeSizeIndex = index;
      const { usSize, chips, measure } = getAllSizesAtIndex(index);

      this.els.resultEmpty.hidden = true;
      this.els.resultActive.hidden = false;

      this.els.resultUs.innerHTML = `${formatRingSize(usSize)} <span>US</span>`;

      this.renderResultDetails({ measure });

      this.els.resultGrid.innerHTML = '';
      chips.forEach(({ label, flag, size, key }) => {
        const chip = document.createElement('span');
        chip.className = 'rsc__result-chip';
        if (key === 'USA') chip.classList.add('is-primary');
        chip.innerHTML = `<img class="rsc__result-chip-flag" src="${flag}" alt="" width="16" height="11" loading="lazy"><span class="rsc__result-chip-country">${label}</span><strong class="rsc__result-chip-size">${formatRingSize(size)}</strong>`;
        this.els.resultGrid.appendChild(chip);
      });

      if (tip) {
        this.els.tip.innerHTML = tip;
        this.els.tip.hidden = false;
      } else {
        this.els.tip.hidden = true;
      }

      this.currentUsSize = usSize;
    }

    showPartialResult(usSize) {
      this.els.resultEmpty.hidden = true;
      this.els.resultActive.hidden = false;
      this.els.resultUs.innerHTML = `${formatRingSize(usSize)} <span>US</span>`;
      this.renderResultDetails({ measure: null });
      this.els.resultGrid.innerHTML = '';
      this.els.tip.hidden = true;
      this.currentUsSize = usSize;
    }

    clearResult() {
      this.activeSizeIndex = null;
      this.currentUsSize = null;
      this.els.resultEmpty.hidden = false;
      this.els.resultActive.hidden = true;
      this.els.sizesGrid.querySelectorAll('.rsc__size-chip').forEach((c) => c.classList.remove('is-active'));
    }

    async copySize() {
      if (!this.currentUsSize) return;
      const text = `${this.currentUsSize} US`;
      try {
        await navigator.clipboard.writeText(text);
        this.els.copyBtn.textContent = 'Copied!';
        this.els.copyBtn.classList.add('is-copied');
        setTimeout(() => {
          this.els.copyBtn.textContent = 'Copy US Size';
          this.els.copyBtn.classList.remove('is-copied');
        }, 2000);
      } catch {
        /* fallback silent */
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-ring-size-converter]').forEach((root) => {
      new RingSizeConverter(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
